import React from "react";
import ChartWidget from "./ChartWidget";
import MetricWidget from "./MetricWidget";
import TableWidget from "./TableWidget";
import PlayerChartWidget from "./PlayerChartWidget";
import MLBScoresWidget from "./MLBScoresWidget";

const Widget = ({ config, onEdit, onDelete }) => {
  const renderWidget = () => {
    switch (config.type) {
      case "chart":
        return (
          <ChartWidget config={config} onEdit={onEdit} onDelete={onDelete} />
        );
      case "metric":
        return (
          <MetricWidget config={config} onEdit={onEdit} onDelete={onDelete} />
        );
      case "table":
        return (
          <TableWidget config={config} onEdit={onEdit} onDelete={onDelete} />
        );
      case "playerChart":
        return (
          <PlayerChartWidget
            config={config}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        );
      case "mlbScores":
        return (
          <MLBScoresWidget
            config={config}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        );
      default:
        return (
          <div style={{ padding: "1rem", textAlign: "center" }}>
            Unknown widget type: {config.type}
          </div>
        );
    }
  };

  return renderWidget();
};

export default Widget;
